<template>
  <div class="sleepTestMovie" v-cloak>
    <v-container>
      <v-row class="sleepTestMovie_top" ref="top">
        <v-card class="sleepTestMovie_main">
          <div id="viemo_block">
            <iframe
              :src="getSleepTest.contents[getSleepTestIndex].movieUrl"
              frameborder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              webkitAllowFullScreen
              mozallowfullscreen
              allowfullscreen
              style="position:absolute;top:0;left:0;width:100%;height:100%;"
              :title="getSleepTest.contents[getSleepTestIndex].title"
            ></iframe>
          </div>
        </v-card>
      </v-row>
      <v-row class="sleepTestMovie_cont" v-if="!isFinished">
        <v-col cols="12">
          <div class="sleepTestMovie_titleField">
            <span class="sleepTestMovie_title">{{
              getSleepTest.contents[getSleepTestIndex].title
            }}</span>
          </div>
          <div
            v-for="(item, index) in questions"
            :key="index"
            class="sleepTestMovie_question bottom_border"
          >
            <p class="sleepTestMovie_title">
              <span class="question_num">Q{{ index + 1 }}．</span>
              <span class="question_title">{{ item.question }}</span>
            </p>
            <ul class="answer_list">
              <li
                v-for="(select_item, select_index) in item.selection"
                :key="select_index"
                class="select_item"
              >
                <label
                  :for="'input-' + index + '-' + select_index"
                  class="checkbox_label checkbox_label-narrow"
                  :class="{ 'is-pressed': answers[index] == select_index }"
                >
                  <input
                    type="radio"
                    class="radio_input"
                    :name="'input-' + select_index"
                    :value="select_index"
                    :id="'input-' + index + '-' + select_index"
                    v-model="answers[index]"
                  />
                  {{ select_item }}
                </label>
              </li>
            </ul>
          </div>
          <div class="btn_layout">
            <button
              class="sleepTestTop_menuTtl btn_next"
              v-on:click="checkAnswer()"
              :class="{ 'is-negative': !isAnswered }"
              v-if="this.questions.length != 0"
            >
              採点する
            </button>
            <!-- <button
              class="sleepTestTop_menuTtl btn_next"
              v-on:click="backPage()"
              :class="{ 'is-negative': !isAnswered }"
              v-else
            >
              動画一覧に戻る
            </button> -->
          </div>
        </v-col>
      </v-row>
      <v-row class="sleepTestMovie_cont" v-if="isFinished">
        <div class="sleepTestMovie_titleField">
          <span class="sleepTestMovie_title">{{
            getSleepTest.contents[getSleepTestIndex].title
          }}</span>
        </div>
        <v-col cols="12" class="sleepTestMovie_result">
          <div style="padding-bottom:5px;" class="bottom_border_answer">
            <table style="margin: 0 auto;">
              <tr>
                <td>
                  <div style="display:inline-block;" class="circle">
                    <span class="scoreText">スコア</span>
                  </div>
                </td>
                <td>
                  <span class="sleepTestMovie_correctCount">
                    {{ correctCount }}問正解
                  </span>
                  <span class="sleepTestMovie_questionCount"
                    >/{{ this.questions.length }}問中</span
                  >
                </td>
              </tr>
            </table>
          </div>
          <div
            v-for="(item, index) in this.questions"
            :key="index"
            class="sleepTestMovie_answer bottom_border_answer"
          >
            <p class="sleepTestMovie_titleAnswer">
              <span class="question_num">Q{{ index + 1 }}．</span>
              <span class="question_title">{{ item.question }}</span>
            </p>
            <div
              v-if="item.answer == answers[index]"
              class="answered_item correct"
            >
              <div class="maruBox"><div class="maruMark"></div></div>
              <p class="sleepTestMovie_selectedAnswer">
                {{ item.selection[answers[index]] }}
              </p>
            </div>
            <div v-else class="answered_item wrong">
              <div class="crossBox"><div class="crossMark"></div></div>
              <p class="sleepTestMovie_selectedAnswer">
                {{ item.selection[answers[index]] }}
              </p>
            </div>
            <div class="sleepTestMovie_explainArea">
              <p class="sleepTestMovie_correctAnswer">
                答え: {{ item.selection[item.answer] }}
              </p>
              <p class="sleepTestMovie_explain">{{ item.explain }}</p>
            </div>
          </div>
          <div class="btn_layout">
            <button
              class="sleepTestTop_menuTtl btn_next"
              v-on:click="backPage()"
            >
              動画一覧に戻る
            </button>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
// TODO: questions_urlから問題取得
export default {
  name: "sleepTestMovie",
  data: function() {
    return {
      questions: [],
      answers: [],
      isFinished: false,
    };
  },
  computed: {
    ...mapGetters([
      "getSleepTest",
      "getSleepTestIndex",
      "getLoginUserId",
      "getAccessToken",
    ]),
    completed: function() {
      return this.isFinished;
    },
    isAnswered: function() {
      var isAnswer = true;
      isAnswer = this.answers.length == this.questions.length;
      for (let index = 0; index < this.answers.length; index++) {
        if (this.answers[index] === void 0) {
          isAnswer = false;
        }
      }
      return isAnswer;
    },
    correctCount: function() {
      var count = 0;
      for (let index = 0; index < this.questions.length; index++) {
        if (this.questions[index].answer == this.answers[index]) {
          count += 1;
        }
      }
      return count;
    },
  },
  methods: {
    checkAnswer() {
      this.isFinished = this.isAnswered;
      if (this.isAnswered) {
        const dom = this.$refs.top;
        const rect = dom.getBoundingClientRect();
        window.scrollTo(0, rect.x + rect.height);
      }
    },
    backPage() {
      this.$router.back();
      window.scrollTo(0, 0);
    },
  },
  created() {
    // 遷移時に問題があれば取得する
    if (this.getSleepTest.contents[this.getSleepTestIndex].question != "") {
      axios
        .get("/sleepmovie/quiz", {
          params: {
            userName: this.getLoginUserId,
            name: this.getSleepTest.contents[this.getSleepTestIndex].question,
          },
          headers: { Authorization: this.getAccessToken },
        })
        .then(
          function(response) {
            this.questions = response.data;
          }.bind(this)
        )
        .catch((error) => {
          this.error = error;
          // this.questions = sampleData;
        });
    }
  },
  mounted() {
    let scriptElement = document.createElement("script");
    scriptElement.setAttribute("src", "https://player.vimeo.com/api/player.js");
    document.getElementById("viemo_block").appendChild(scriptElement);
  },
};
</script>
<style lang="scss" scoped>
$xs: "320px";
$sm: "480px";
$md: "800px";
#viemo_block {
  padding: 63.25% 0 0 0;
  position: relative;
}
.sleepTestMovie {
  background: #5592c6;
  min-height: calc(100vh - 96px);
  &_logo {
    width: 160px;
  }
  &_menuTtl {
    padding-left: 50px;
    padding-right: 50px;
  }
  &_title {
    font-size: 28px;
    color: #ffff;
    font-weight: bold;
    line-height: 1.2;
    @media screen and (max-width: $md) {
      font-size: 24px;
    }
  }
  &_titleAnswer {
    font-size: 28px;
    color: #1d64a1;
    font-weight: bold;
    line-height: 1.2;
    @media screen and (max-width: $md) {
      font-size: 24px;
    }
  }
  &_correctCount {
    font-size: 30px;
    color: #1d64a1;
    font-weight: bold;
    @media screen and (max-width: $sm) {
      font-size: 28px;
    }
  }
  &_questionCount {
    font-size: 28px;
    color: #949494;
    font-weight: bold;
    @media screen and (max-width: $sm) {
      font-size: 26px;
    }
  }
  &_top {
    max-width: 980px;
    margin: 0 auto !important;
  }
  &_cont {
    padding: 2em;
    background: rgba(0, 0, 32, 0.2);
    border-radius: 6px;
    margin: 0 auto !important;
    max-width: 980px;
    @media screen and (max-width: $md) {
      padding: 16px;
    }
  }
  &_main {
    background: #fff;
    background-size: 40%;
    padding: 48px;
    width: 100%;
    margin-bottom: 20px;
    @media screen and (max-width: $md) {
      padding: 16px;
      margin-bottom: 10px;
      background-position: right top;
      .btn_next {
        margin-top: 0;
      }
    }
  }
  &_card {
    padding: 48px;
    @media screen and (max-width: $md) {
      padding: 16px;
    }
    p {
      margin: 0;
    }
  }
  &_card-disabled {
    opacity: 0.7;
  }
  &_cardTtl {
    text-align: center;
    font-size: 24px;
    color: #5592c6;
    font-weight: bold;
    @media screen and (max-width: $md) {
      font-size: 20px;
    }
  }
  &_desc {
    font-size: 15px;
    margin-top: 8px !important;
    @media screen and (max-width: $md) {
      font-size: 13px;
      margin-top: 0 !important;
    }
  }
  &_question {
    margin-top: 10px;
    padding-bottom: 20px;
  }
  &_answer {
    margin-top: 10px;
    padding-bottom: 20px;
  }
  &_result {
    background-color: #fff;
    border-radius: 4px;
  }
  &_selectedAnswer {
    color: #fff;
    padding: 12px 40px;
    border-radius: 4px;
  }
  &_correctAnswer {
    font-size: 20px;
    font-weight: bold;
    width: 90%;
    margin-bottom: 2px;
  }
  &_explain {
    font-size: 14px;
  }
  &_explainArea {
    margin: 0 auto;
    width: 90%;
  }
  &_titleField {
    margin-bottom: 1em;
  }
}
.cards {
  margin-top: 100px;
  color: #fff;
  background: rgba(0, 0, 0, 0.1);
  padding: 48px;
}
ul {
  list-style: none;
}
.btn_next {
  display: inline-block;
  color: #fff;
  font-size: 18px;
  padding: 12px 20px 12px 12px;
  min-width: 270px;
  text-align: center;
  background-color: #ff7600;
  border-radius: 28px;
  margin: 8px;
  box-shadow: 0 2px 4px 0px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  @media screen and (max-width: $md) {
    margin: 24px 0 0;
  }
  &:hover {
    opacity: 0.9;
  }
  &.is-negative {
    opacity: 0.5;
    cursor: default;
    &:hover {
      opacity: 0.5;
    }
  }
  &-lg {
    padding: 16px 24px 16px 16px;
    font-size: 24px;
    letter-spacing: 0.05em;
    border-radius: 36px;
    font-weight: bold;
    min-width: 280px;
    &::after {
      top: 24px;
      right: 28px;
    }
  }
}
.checkbox {
  &_label {
    display: inline-block;
    color: #4477a3;
    padding: 24px;
    // min-width: 160px;
    width: 90%;
    text-align: left;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 4px 0 0 rgba(255, 255, 255, 0.5);
    margin: 8px;
    font-size: 18px;
    letter-spacing: 0.04em;
    font-weight: bold;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(255, 153, 0, 0.5);
    transition: background-color 0.1s ease;
    &:hover {
      @media screen and (min-width: $md) {
        background: #f90;
        box-shadow: 0 4px 0 0 #c30;
        color: #fff;
        border-color: #f90;
      }
      @media screen and (max-width: $md) {
        animation: pressed 0.2s ease;
      }
    }
    @media screen and (max-width: $sm) {
      font-size: 14px;
      // width: 90%;
      padding: 12px 16px;
      margin: 8px 0;
    }
  }
  &_label-narrow {
    padding: 12px 24px;
  }
  &_label:active {
    animation: pressed 0.2s ease;
    background: #f90;
    box-shadow: 0 4px 0 0 #c30;
    color: #fff;
    border-color: #f90;
  }
  &_label.is-pressed {
    animation: pressed 0.2s ease;
    background: #f90;
    box-shadow: 0 4px 0 0 #c30;
    color: #fff;
    border-color: #f90;
  }
}
.bottom_border {
  border-bottom: solid 0.1px #fff;
}
.bottom_border_answer {
  border-bottom: solid 0.1px rgb(150, 150, 150);
}
.select_item {
  text-align: center;
}
.question_num {
  font-size: 28px;
  @media screen and (max-width: $sm) {
    font-size: 20px;
  }
}
.question_title {
  font-size: 24px;
  @media screen and (max-width: $sm) {
    font-size: 18px;
  }
}
.btn_layout {
  text-align: center;
}
.maruBox {
  height: 0;
  transform: translate(15px, 0.9em);
}
.maruMark {
  content: "";
  display: inline-block;
  width: 18px;
  height: 18px;
  text-align: center;
  line-height: 10px;
  border-radius: 50%;
  border: solid 3px #fff;
}
.crossBox {
  transform: translate(15px, 1.3em);
}
.crossMark {
  display: block;
  width: 18px; /*枠の大きさ*/
  position: relative;
}
.crossMark::before,
.crossMark::after {
  content: "";
  display: block;
  width: 100%; /*バツ線の長さ*/
  height: 3px; /*バツ線の太さ*/
  background: #fff;
  transform: rotate(45deg);
  transform-origin: 0% 50%;
  position: absolute;
  top: calc(14% - 5px);
  left: 14%;
}
.crossMark::after {
  transform: rotate(-45deg);
  transform-origin: 100% 50%;
  left: auto;
  right: 14%;
}
.answered_item {
  width: 90%;
}
.wrong {
  background-color: rgb(255, 67, 79);
  border-radius: 4px;
  margin: 0 auto;
}
.correct {
  background-color: rgb(108, 206, 111);
  border-radius: 4px;
  margin: 0 auto;
}
.circle {
  height: 80px;
  width: 80px;
  border-radius: 50%;
  line-height: 80px;
  text-align: center;
  background-color: #4477a3;
  margin-right: 0.8em;
  @media screen and (max-width: $sm) {
    height: 50px;
    width: 50px;
    line-height: 50px;
  }
}
.scoreText {
  color: #fff;
  font-size: 20px;
  @media screen and (max-width: $sm) {
    font-size: 14px;
  }
}
.answerMark {
  border-radius: 4px;
  font-weight: bold;
  font-size: 16px;
  font-family: "Noto Sans JP";
}
@keyframes pressed {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(0.98);
  }
  50% {
    transform: scale(1.02);
  }
  100% {
    transform: scale(1);
  }
}
[v-cloak] {
  display: none;
}
</style>
